'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./homePageRework/gallery-section'));
    processInclude(require('./homePageRework/discover-section'));
});
